import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface GenerateBusinessUnitFacilitiesSkills {
  actionName: 'generateBusinessUnitFacilitiesSkills';
  request: mtechnavi.api.company.IGenerateBusinessUnitFacilitiesSkillsRequest;
}

export const generateBusinessUnitFacilitiesSkills = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IGenerateBusinessUnitFacilitiesSkillsRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/GenerateBusinessUnitFacilitiesSkills';

  const result = await worker.invokeListRequest(execMethodName, {
    prompt: req.prompt,
  });
  return result;
};
